import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/home')
        }
      ]
    },{
      path: '/about',
      redirect: '/about',
      component: Layout,
      children: [
        {
          path: '',
          name: 'AboutDetail',
          component: () => import('@/views/about/about')
        }, {
          path: 'qualifications',
          name: 'Qualifications',
          component: () => import('@/views/about/qualifications')
        }, {
          path: 'culture',
          name: 'Culture',
          component: () => import('@/views/about/culture')
        }
      ]
    },{
      path: '/news',
      component: Layout,
      children: [
        {
          path: '',
          name: 'NewsList',
          component: () => import('@/views/news/list')
        },{
          path: 'detail',
          name: 'NewsDetail',
          component: () => import('@/views/news/detail')
        }
      ]
    },{
      path: '/contact',
      component: Layout,
      children:[
        {
          path: '',
          name: 'Contact',
          component: () => import('@/views/contact')
        }
      ]
    }, {
      path: '/history',
      component: Layout,
      children: [
        {
          path: '',
          name: 'History',
          component: () => import('@/views/history')
        }
      ]
    }, {
      path: '/joinUs',
      component: Layout,
      children: [
        {
          path: '',
          name: 'JoinUs',
          component: () => import('@/views/joinUs')
        }
      ]
    }, {
      path: '/PTC',
      component: Layout,
      children: [
        {
          path: '',
          name: 'PTC',
          component: () => import('@/views/PTC/list')
        }
      ]
    }, {
      path: '/report',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Report',
          component: () => import('@/views/report')
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return new Promise((resolve, reject) => {
        setTimeout(() => { // 使用 setTimeout 来模拟平滑滚动效果（因为 window.scrollTo 不直接支持 smooth）
          window.scrollTo({ top: 0, behavior: 'smooth' });
          resolve(); // 确保 Promise 被解决，以避免警告信息
        }, 100); // 可以根据需要调整延迟时间以实现更平滑的滚动效果
      });
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js